import {registerRoot} from 'remotion';
import {RemotionRoot} from './components/Root';

registerRoot(RemotionRoot);
